const ASSETS = {
  "wordmark-light": "/brand/wordmark-on-black.png",
  "wordmark-dark": "/brand/wordmark-on-white.png",
  "mark-light": "/brand/mark-on-black.png",
  "mark-dark": "/brand/mark-on-white.png",
};

/**
 * Authoritative Endure Beyond "Trailblazer" wordmark/mark artwork.
 * variant: "wordmark-light" (white-on-dark, default) | "wordmark-dark" (black-on-light)
 *        | "mark-light" | "mark-dark" — used where space is limited.
 * Never retype, re-tilt, stretch or alter letter-spacing — this renders the supplied artwork only.
 */
export function Logo({ variant = "wordmark-light", className = "h-5 w-auto", testId = "brand-logo" }) {
  return (
    <img
      src={ASSETS[variant]}
      alt="Endure Beyond"
      data-testid={testId}
      className={className}
      draggable={false}
    />
  );
}
